// B"H
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import PrivacyPolicy from "./components/PrivacyPolicy";
import DeleteAccount from "./components/DeleteAccount";
import Navbar from "./components/Navbar";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route
          path="/"
          element={
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                backgroundColor: "#1C3854",
                minHeight: "100vh",
                alignItems: "center",
                color: "#fff",
                fontFamily: "Poppins, sans-serif",
                paddingTop: "64px",
              }}
            >
              <div
                style={{
                  width: "80%",
                  maxWidth: "800px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  padding: "4rem 0",
                }}
              >
                <h1 style={{ textAlign: "center", marginBottom: "1rem" }}>
                  Zuz Giving Technologies Pty Ltd
                </h1>
                <h2
                  style={{
                    textAlign: "center",
                    marginBottom: "2rem",
                    color: "rgba(255, 255, 255, 0.9)",
                  }}
                >
                  A smarter way to give.
                </h2>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2rem",
                    fontSize: "1.1rem",
                    lineHeight: "1.6",
                  }}
                >
                  <p>
                    Zuz is an online platform designed to simplify and
                    streamline charitable giving. Whether you're making a
                    one-time donation or regularly setting aside ma'aser, Zuz
                    helps you give with intention and impact.
                  </p>

                  <p>
                    With just a few taps, users can donate to multiple causes,
                    track their giving history, and stay connected with the
                    organizations they care about. All donations made through
                    Zuz are processed securely, and eligible donations come with
                    tax-deductible receipts — making your giving both meaningful
                    and financially efficient.
                  </p>

                  <div>
                    <h3 style={{ marginBottom: "1rem" }}>Key features:</h3>
                    <ul
                      style={{
                        listStyle: "none",
                        padding: 0,
                        display: "flex",
                        flexDirection: "column",
                        gap: "0.75rem",
                      }}
                    >
                      <li
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.5rem",
                        }}
                      >
                        <span style={{ color: "#4CAF50" }}>✓</span>
                        Easily manage and track all your charitable giving
                      </li>
                      <li
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.5rem",
                        }}
                      >
                        <span style={{ color: "#4CAF50" }}>✓</span>
                        Promote the mitzvah of ma'aser
                      </li>
                      <li
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.5rem",
                        }}
                      >
                        <span style={{ color: "#4CAF50" }}>✓</span>
                        Support multiple organizations in one place
                      </li>
                      <li
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.5rem",
                        }}
                      >
                        <span style={{ color: "#4CAF50" }}>✓</span>
                        Receive tax-deductible donation receipts
                      </li>
                      <li
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.5rem",
                        }}
                      >
                        <span style={{ color: "#4CAF50" }}>✓</span>
                        Secure payments with trusted platforms
                      </li>
                    </ul>
                  </div>

                  <p
                    style={{
                      marginTop: "1rem",
                      fontStyle: "italic",
                      color: "rgba(255, 255, 255, 0.9)",
                      textAlign: "center",
                    }}
                  >
                    Zuz is operated by Zuz Giving Technologies Pty Ltd and is
                    committed to ethical, impactful, and user-focused
                    philanthropy.
                  </p>

                  <div
                    style={{
                      marginTop: "3rem",
                      padding: "2rem",
                      backgroundColor: "rgba(255, 255, 255, 0.1)",
                      borderRadius: "12px",
                      textAlign: "center",
                    }}
                  >
                    <h3 style={{ marginBottom: "1rem", fontSize: "1.5rem" }}>
                      Need Help or Have Questions?
                    </h3>
                    <p style={{ marginBottom: "1.5rem" }}>
                      Our support team is here to assist you. Whether you have
                      questions about donations, need technical support, or want
                      to learn more about how Zuz works, we're happy to help.
                    </p>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "1rem",
                      }}
                    >
                      <p style={{ fontSize: "1.1rem", fontWeight: 500 }}>
                        Contact us at:
                      </p>
                      <a
                        href="mailto:support@zuz.giving"
                        style={{
                          color: "#4CAF50",
                          fontSize: "1.2rem",
                          fontWeight: "600",
                          textDecoration: "none",
                          padding: "0.75rem 1.5rem",
                          backgroundColor: "rgba(76, 175, 80, 0.1)",
                          borderRadius: "8px",
                          transition: "all 0.3s ease",
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.backgroundColor =
                            "rgba(76, 175, 80, 0.2)";
                          e.currentTarget.style.transform = "scale(1.05)";
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.backgroundColor =
                            "rgba(76, 175, 80, 0.1)";
                          e.currentTarget.style.transform = "scale(1)";
                        }}
                      >
                        support@zuz.giving
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
      </Routes>
    </Router>
  );
}

export default App;
